module.exports = __webpack_public_path__ + "80f57616d0d2ccd342c398ef2de83b83.png";